var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"need-help flex align-center"},[_c(require("@/assets/icons/helpcenter.svg"),{tag:"component"}),_c('p',{staticClass:"ml-1 text-rock body-2 w-500"},[_vm._v(_vm._s(_vm.$t('i_need_help')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }